//
//
//
//
//
//
//
//
//
//
//
//

import uParse from '@/components/gaoyia-parse/parse.vue'
export default{
	data(){
		return {
			moreTitle:'查看更多',
			show:true,
			height:0,
			content:''
		}
	},
	props:{
		detail:{
			type:String,
			default:''
		}
	},
	watch:{
		'detail' (){
			let _this=this
			this.content = this.detail
				setTimeout(()=>{							
					let dom=uni.createSelectorQuery().in(this).select('.detail')
					dom.fields({size:true},data=>{
						_this.height=data.height
						if(data.height>400){
							this.show=false
						}
					}).exec()
				},1000)
		}
	},
	components:{
		uParse
	},
	methods:{
		showContent(){
			this.show=!this.show
		}
	}
}
